import React from 'react';
import styled from 'styled-components';
import { Flex } from 'reflexbox';

import { SettingsLabel, SettingHeader, SettingsContainer } from './BranchComponents';
import BranchCheckbox from './BranchCheckbox';

import { DAYS, POSTAL_REGIONS, SHORT_DAYS_MAP } from '../constants';

const PostalDeliverySettings = ({ pharmacy, onChange }) => {
  const { postal_partner } = pharmacy;
  const { region: pharmacyPostalRegions, postalTimeslot } = postal_partner || {};

  const createTimeslotChangeHandler = updatedTimeslot => checked => {
    let updatedTimeslots = postalTimeslot ? [...postalTimeslot] : [];

    if (checked) updatedTimeslots.push(updatedTimeslot);
    else updatedTimeslots = updatedTimeslots.filter(timeslot => timeslot !== updatedTimeslot);

    onChange('postal_partner.postalTimeslot', updatedTimeslots);
  };

  const createPostalRegionChange = updatedRegion => checked => {
    let updatedRegions = pharmacyPostalRegions ? [...pharmacyPostalRegions] : [];

    if (checked) updatedRegions.push(updatedRegion);
    else updatedRegions = updatedRegions.filter(region => region !== updatedRegion);

    onChange('postal_partner.region', updatedRegions);
  };

  return (
    <SettingsContainer>
      <SettingHeader>Postal delivery settings</SettingHeader>
      <SettingsLabel>Delivery days</SettingsLabel>
      <Flex>
        {DAYS.map(day => (
          <DeliveryCheckbox
            key={day}
            checked={
              postalTimeslot?.length &&
              postalTimeslot.includes(SHORT_DAYS_MAP[day])
            }
            onChange={createTimeslotChangeHandler(SHORT_DAYS_MAP[day])}
          >
            {day}
          </DeliveryCheckbox>
        ))}
      </Flex>
      <SettingsLabel>Postal regions</SettingsLabel>
      <Flex>
        {POSTAL_REGIONS.map(postalRegion => (
          <DeliveryCheckbox
            key={postalRegion}
            checked={
              pharmacyPostalRegions?.length &&
              pharmacyPostalRegions.includes(postalRegion)
            }
            onChange={createPostalRegionChange(postalRegion)}
          >
            {postalRegion}
          </DeliveryCheckbox>
        ))}
      </Flex>
    </SettingsContainer>
  );
};

const DeliveryCheckbox = styled(BranchCheckbox)`
  margin-right: 8px;
`;

export default PostalDeliverySettings;
